<template>
  <div class="warp">
    <navBox :page="'Cooperation'"></navBox>
    
    <div class="">

      <Secondary :bgImage="bgImage" :Cntitle="Cntitle" :Entitle="Entitle">
          <template>
            <div  class="custom-layout">

                <div class="paragraph">
                  <div>加入约剑</div>
                  <div>我们致力于不断改进，提高您和选手的体验。</div>
                  <div>想了解更多，加入我们，或有任何问题，直接联系我们。</div>
                  <div>我们随时准备回答您的疑问，探讨合作机会。</div>
                </div>

                <div class="paragraph">
                  <div>联系电话（微信同步）： +86 13316113801</div>
                  <div>联系邮箱：winkid@fencerpage.com</div>
                </div>

            </div>
        </template>
      </Secondary>

    </div>
  </div>
</template>

<script>
import NavBox from '@/components/navBox.vue';
import Secondary from '../components/secondary.vue';
export default {
  name: 'ServePage',
  components:{ Secondary, NavBox },
  data(){
    return{
      Entitle: "COOPERATE",
      Cntitle: "商务合作",
      bgImage:"https://img.fencerspage.com/upload/oss/club/contest/20250317/325567d7de378ab59.jpg",
    }
  },

  
  methods:{
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$media_num: 1200px;  // 屏幕宽度


.warp {
  margin: 0 auto;
  width: 100vw;
}

.media_box{
  width: 100vw;
  height: 50vw;
  font-size: 0.88vw; //17

  @media only screen and (max-width: $media_num) {
    width: 1200px;
    height:600px;  // 0.5*width
  }
}

.custom-layout{
  font-size: 1.85em;
  letter-spacing: 0.03em;

  .text-indent{
    text-indent: 2em;
  }

  .paragraph{
    padding-bottom: 3em;
    line-height: 1.8em;
  }
}
</style>
